import { ReactNode } from 'react';

interface PageBodyProps {
  children: ReactNode;
  /** When true the body fills available space and scrolls internally (used for tables). */
  fill?: boolean;
  /** When true the body has standard page padding. Disable for edge-to-edge tables. */
  padded?: boolean;
}

export function PageBody({ children, fill = true, padded = true }: PageBodyProps) {
  const layout = fill ? 'flex-1 min-h-0 overflow-auto' : '';
  const padding = padded ? 'p-6' : '';
  return <div className={`bg-panel ${layout} ${padding}`}>{children}</div>;
}
